import { RCAlertBox, RCStarRating } from '@reverbdotcom/cadence/components';
import React from 'react';
import {
  CoreProductReviews,
  ProductReviewCSPFields,
} from '../schemas/rql';
import I18n from 'i18n-js';
import ProductReviewsRating from './ProductReviewsRating';
import { AlertType } from '@reverbdotcom/cadence/components/types';
import { ProductReviewFormButton } from './ProductReviewFormButton';

export interface ProductReviewCreateResult {
  alertType: AlertType;
  message: string;
}

interface Props {
  stats: CoreProductReviews.Stats;
  csp: ProductReviewCSPFields.Fragment;
  trackingDisplayStyle: 'product' | 'csp';
}

function roundRating(rating) {
  return rating.toFixed(1);
}

export function ProductReviewsHeader(props: Props) {
  const [result, setResult] = React.useState<ProductReviewCreateResult>(null);
  const { stats, csp, trackingDisplayStyle } = props;

  if (!stats) {
    return null;
  }

  return (
    <>
      {result && (
        <div className="mb-4">
          <RCAlertBox type={result.alertType}>
            {result.message}
          </RCAlertBox>
        </div>
      )}
      {stats.total > 0 ?
        <div className="width-100">
          <div className="d-flex gap-2 fx-wrap">
            <div className="fx-grow fx-width-40">
              <div className="d-flex size-250 weight-bold">
                <span className="mr-2">
                  {roundRating(stats.averageRating)}
                </span>
                <RCStarRating
                  rating={stats.averageRating / 5}
                  hideTooltip
                  largeStars
                />
              </div>
              {I18n.t('discovery.productReviews.header.subtitle', { averageRating: roundRating(stats.averageRating), count: stats.total })}
              <div className="mt-4">
                <ProductReviewFormButton
                  onResponse={setResult}
                  csp={csp}
                  trackingDisplayStyle={trackingDisplayStyle}
                />
              </div>
            </div>
            <div className="fx-grow fx-width-50">
              {stats.ratingsDistribution.slice().reverse().map((ratingDistribution) => (
                <ProductReviewsRating
                  total={stats.total}
                  ratingDistribution={ratingDistribution}
                  key={ratingDistribution.rating}
                  trackingDisplayStyle={trackingDisplayStyle}
                  cspId={csp.id}
                />
              ))}
            </div>
          </div>
        </div> :
        <p>{I18n.t('discovery.productReviews.header.noReviews')}</p>
      }
    </>
  );
}
